import {countryData, ICountryData} from '../../data/constants/country';

/**
 * Convertit le nom du pays en code pays ISO2 pour les numéros de téléphone
 * @param {string} countryName - Nom du pays
 * @returns {string} Code pays au format ISO 2 pour les numéros de téléphone
 */
export const getCountryCodeFromName = (countryName: string): string => {
  if (!countryName) return 'FR';

  // Chercher le pays dans countryData avec correspondance exacte
  const country = countryData.find(
    c => c.name.toLowerCase() === countryName.toLowerCase(),
  );

  if (country) {
    return country.code;
  }

  // Recherche partielle si la correspondance exacte échoue
  const possibleCountry = countryData.find(
    c =>
      countryName.toLowerCase().includes(c.name.toLowerCase()) ||
      c.name.toLowerCase().includes(countryName.toLowerCase()),
  );

  if (possibleCountry) {
    return possibleCountry.code;
  }

  // Valeur par défaut si aucune correspondance n'est trouvée
  return 'FR';
};

export const generateCountryCodeMap = (
  countryData: ICountryData[],
): {[key: string]: string} => {
  return countryData.reduce((acc, country) => {
    acc[country.name] = country.code;
    return acc;
  }, {} as {[key: string]: string});
};
